import React from 'react'

import {
  PAY_AS_YOU_GO_VALUE
} from './config/constants'

import CreditCardForm from './credit_card_form'

class SessionCheckoutForm extends React.Component {
  calculateTotalAmount () {
    const minutes = this.props.bookData.requestData.get('sessionLength')

    if (minutes === PAY_AS_YOU_GO_VALUE) return PAY_AS_YOU_GO_VALUE

    const expertRateByMinute = parseInt(this.props.expert.get('hourlyRate'), 10) / 60

    return minutes * expertRateByMinute
  }

  renderAmountSection () {
    if (this.props.bookData && this.props.bookData.requestData.get('sessionLength') === PAY_AS_YOU_GO_VALUE) {
      return (
        <div className='section'>
          <h4>PAY AS YOU GO</h4>
          <p>Your card will be charged at the conclusion of your session.</p>
        </div>
      )
    }
    return (
      <div className='section'>
        <h4>Total amount: <b>${this.calculateTotalAmount()}</b></h4>
      </div>
    )
  }

  render () {
    return (
      <div className='book-session'>
        {this.renderAmountSection()}
        <div className='section'>
          <div className='gray-box'>
            <p style={{marginBottom: 10}}>Please enter your credit card information.</p>
            <CreditCardForm
              amount={this.calculateTotalAmount()}
              sessionId={this.props.bookData.sessionId}
              sessionLength={this.props.bookData.requestData.get('sessionLength')}
              sessionStartTime={this.props.bookData.requestData.get('startTime')}
              type={this.props.bookData.requestData.get('type')}
              expert={this.props.expert}
              expertUid={this.props.expert.get('uid')}
              expertName={this.props.expert.get('name')}
              user={this.props.user}
              userUid={this.props.user.get('uid')}
              userName={this.props.user.get('name')}
              sendPayoutRequest={this.props.sendPayoutRequest}
              setLaterSessionSideEffects={this.props.setLaterSessionSideEffects}
              setImmediateSessionSideEffects={this.props.setImmediateSessionSideEffects}
              onCheckoutComplete={this.props.onCheckoutComplete}/>
          </div>
        </div>
      </div>
    )
  }
}

export default SessionCheckoutForm



/** WEBPACK FOOTER **
 ** ./modules/shared/session_checkout_form.js
 **/